(function () {
  if (window.__starlightRivyoReviewSync) return;
  window.__starlightRivyoReviewSync = true;

  var badgeSelector = '.wc_product_review_badge.product-rating-rivyo';
  var reviewSectionSelector = '#wc_review_section';
  var reviewSortSelector = '#wc_review_section #sort_by';
  var pendingFrame = null;
  var initialSortApplied = false;

  function getReviewCount() {
    var section = document.querySelector(reviewSectionSelector);
    if (!section) return '';
    var summary = section.querySelector('.wc_review_summary_count_text');
    var tab = section.querySelector('.wc_rivyo_tab_toggle');
    var text = summary && summary.textContent || tab && tab.textContent || '';
    var match = text.match(/(?:Based on|Reviews?\s*\()\s*([\d,]+)/i);
    return match ? match[1] : '';
  }

  function syncBadgeCount() {
    pendingFrame = null;
    setPicturesFirstSort();
    var count = getReviewCount();
    if (!count) return;
    document.querySelectorAll(badgeSelector).forEach(function (badge) {
      badge.querySelectorAll('.ratingCount').forEach(function (node) {
        if (node.textContent !== count) node.textContent = count;
      });
      badge.setAttribute('aria-label', 'Read product reviews (' + count + ')');
    });
  }

  function setPicturesFirstSort() {
    if (initialSortApplied) return;
    var select = document.querySelector(reviewSortSelector);
    if (!select) return;
    var target = Array.from(select.options).find(function (option) {
      return option.value === 'pictures-first' || option.textContent.trim().toLowerCase() === 'pictures first';
    });
    if (!target) return;
    initialSortApplied = true;
    if (select.value === target.value) return;
    select.value = target.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function scheduleSync() {
    if (pendingFrame === null) pendingFrame = window.requestAnimationFrame(syncBadgeCount);
  }

  function scrollToReviews() {
    var section = document.querySelector(reviewSectionSelector);
    if (!section) return;
    section.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function handleBadgeActivation(event) {
    var badge = event.target.closest && event.target.closest(badgeSelector);
    if (!badge) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    scrollToReviews();
  }

  function init() {
    scheduleSync();
    document.addEventListener('click', handleBadgeActivation);
    document.addEventListener('keydown', handleBadgeActivation);
    new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
